<template>
  <div style="position: relative; overflow: visible">
    <zueri9-state v-if="mdAndDown" class="my-2" :column="{columnName:'zueri9State'}" :absence="absence"></zueri9-state>
    <ws-chip v-if="lgAndUp" v-model="updatedAt" :is-disabled="isDisabled"></ws-chip>
    <div v-if="mdAndDown" class="d-flex justify-center caption" style="font-size: 0.7em !important">{{ updatedAt }}</div>
    <div v-if="mdAndDown" class="d-flex justify-center caption" style="font-size: 0.7em !important">{{ absence.disponent }}</div>
    <div v-if="badge" class="update-badge">{{ badge }}</div>
  </div>
</template>
<script>
import dateTimeMixin from '@/mixins/dateTimeMixin';
import WsChip from '@/modules/customerVbzWorksheet/components/WsChip.vue';
import wsMixin from '@/modules/customerVbzWorksheet/wsMixin';
import commonMixin from '@/mixins/common';
import Zueri9State from '@/modules/customerVbzWorksheet/viewComponents/absences/absencesVirtualScroller/absenceTableCells/Zueri9State.vue';

export default {
  name: 'LastModified',
  components: { Zueri9State, WsChip },
  mixins: [commonMixin, wsMixin],
  props: {
    column: Object,
    absence: Object,
    isAssignedToDifferentView: Boolean,
    isDisabled: { type: Boolean, default: false },
  },
  data() {
    return {
      badgeText: null,
    };
  },
  computed: {
    updatedAt() {
      return this.mx_lastModified(this.absence);
    },
    badge() {
      if (this.absence._created) return 'new';
      if (this.absence._updated) return 'updated';

      return null;
    },
  },
};
</script>
<style scoped>
.update-badge {
  position: absolute;
  top: -1px;
  right: -4px;
  z-index: 10000;
  padding: 0 5px;
  background: red;
  color: white;
  font-size: 10px;
  font-weight: bold;
  border-radius: 6px;
}
</style>